
import React, { useEffect, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { currentLang, currentLangParam } from '../../components/components/utils';
import AppContext from '../../components/AppContext';
import PopupLink from '../../templates/PopupLink';

function SuccessPage({navigation}) {
	const appContext = useContext(AppContext);
    const { nameOfSubmitter, submissionDate, submissionTime, proceedingName } = navigation.state.params;
    let { documentList } = navigation.state.params;
    if (!documentList) { documentList = [] }
    const labels = { // TODO: PUT THE LABELS IN EN.JSON AND FR.JSON
        "successful-submission.banner":                           useIntl().formatMessage({id:"successful-submission.banner"}, {p: (chunks) => <p>{chunks}</p>, a: (chunks) => <a href={"mailto:simaregistry-depotlmsi@cbsa-asfc.gc.ca"}>{chunks}</a>})
        , "successful-submission.submitted-by":                   useIntl().formatMessage({id:"successful-submission.submitted-by"})
        , "successful-submission.submitted-date":                 useIntl().formatMessage({id:"successful-submission.submitted-date"})
        , "successful-submission.submitted-time":                 useIntl().formatMessage({id:"successful-submission.submitted-time"})
        , "successful-submission.submitted-documents":            useIntl().formatMessage({id:"successful-submission.submitted-documents"}, {s: documentList.length < 2 ? '' : 's', u: documentList.length < 2 ? 'u' : 'es'}) //document.querySelectorAll('.selected-row').length === 1 ? '' : 's'})
        , "successful-submission.submitted-no-documents":         useIntl().formatMessage({id:"successful-submission.submitted-no-documents"})
        , "successful-submission.submitted-proceeding":           useIntl().formatMessage({id:"successful-submission.submitted-proceeding"})
        , "successful-submission.submitted-no-proceeding":        useIntl().formatMessage({id:"successful-submission.submitted-no-proceeding"})
    }


	useEffect(() => {
		appContext.setDynamicPageTitle(<FormattedMessage id="sima.btn.efiling.success" />);
	}, []);


    useEffect(() => {
        appContext.setFlashNotice({duration:-1, messages:[labels["successful-submission.banner"]]}); //[labels["http.networkError"]]});
    }, [appContext]);

    function handleClick() {
        navigation.navigate("SecureEFiling", currentLangParam());
    }

    const confirmationData = {
        [labels["successful-submission.submitted-by"]]: nameOfSubmitter,
        [labels["successful-submission.submitted-date"]]: submissionDate,
        [labels["successful-submission.submitted-time"]]: submissionTime,
        [documentList.length === 0 ? labels["successful-submission.submitted-no-documents"] : labels["successful-submission.submitted-documents"]]: documentList,
        [!!proceedingName ? labels["successful-submission.submitted-proceeding"] : labels["successful-submission.submitted-no-proceeding"]]: proceedingName
    }

    const formatFileName = (fileName) => {
		const maxLength = 248;
		const extensionMatch = fileName.match(/\.[0-9a-zA-Z]+$/i);
		const extension = extensionMatch ? extensionMatch[0] : "";
		const nameWithoutExtension = fileName.replace(extension, "");

		let trimmedName = nameWithoutExtension;

		if (nameWithoutExtension.length > maxLength) {
			trimmedName = nameWithoutExtension.slice(0, maxLength) + "..."
		}

		return trimmedName + extension;
	}

    return (
        <>
            <br />
            {
                Object.keys(confirmationData).map((title, index) => (
                    <div className="form-group col-md-12 text-left span-columnist">
                        <span className="span-columns-left">
                            {title}
                        </span>
                        <span className="span-columns-right">
                            {typeof(confirmationData[title]) === 'object' ?
                                documentList.length === 0 ?
                                    <>-</>
                                :
                                    confirmationData[title].map((docName) => (
                                        <li>{formatFileName(docName)}</li>
                                    ))
                            :
                                !!confirmationData[title] ?
                                    confirmationData[title]
                                :
                                    <>-</>
                            }
                        </span>
                    </div>
                ))
            }
            <div className="magical-incantation" style={{height:"50px"}}></div>
            <div className="form-group col-md-12 text-left">
                <button className="link" onClick={handleClick}><FormattedMessage id="successful-submission.fill-another-E-Filing-form" /></button>
            </div>
        </>
    )
}

SuccessPage.path = "";
SuccessPage.navigationOptions = {
	pageTitle: undefined
	, breadcrumb: [
		<PopupLink url={window.env["canada-url"][currentLang()]}><FormattedMessage id="breadcrumb.Canada.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.CBSA.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.ACE.text" /></PopupLink>
	]
	, breadcrumbTitle: <FormattedMessage id="sima.btn.efiling.success" />
};

export default SuccessPage;